export default {"src":"/_next/static/media/apple_white.76116cbd.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};